<div class="game" [style.background-image]="statesService.backgroundImageSrc">
  @if (statesService.frolicNumber === 2) {
    <div class="pic one"></div>
  }
  @if (statesService.frolicNumber === 3) {
    <div class="pic two"></div>
  }
  @if (statesService.frolicNumber === 1) {
    <div class="pic three"></div>
  }
  @if (statesService.frolicNumber === 0) {
    <div class="pic four"></div>
  }
  <img src="assets/bilder/anderes/baeume.webp" alt="bäume" class="pic trees">
</div>
